import { API_BASE_URL } from "@kupikupi/brand";
import { useMutation } from "@tanstack/react-query";
import type { CaptchaTokenProvider } from "../captcha-retry";
import { loginUser } from "../endpoints/user";
import type { LoginRequest } from "../types/user";

interface CaptchaProviderOpts {
  captchaTokenProvider?: CaptchaTokenProvider | undefined;
}

/** Wraps `POST /user/login`. Backend validates a fresh SmartCaptcha token per attempt. */
export function useLogin(opts: CaptchaProviderOpts = {}) {
  return useMutation({
    mutationFn: async (body: LoginRequest) => {
      const captchaToken = await opts.captchaTokenProvider?.();
      return loginUser(
        { baseUrl: API_BASE_URL },
        captchaToken === undefined ? body : { ...body, captchaToken },
      );
    },
  });
}
